export enum LoginMethods {
  LOOKUP_SECRET = 'lookup_secret',
  PASSWORD = 'password',
  OIDC = 'oidc',
  TOTP = 'totp',
  WEB_AUTHN = 'webauthn',
}
